import { useQuery } from "react-query";
import axios from "axios";
import { FERA_PUBLIC_KEY } from "../config";

export const useReviews = (productId, initialData = {}) => {
	const data = useQuery(
		[`reviews`, productId],
		async () => {
			const { data } = await axios({
				method: "GET",
				url: `https://api.fera.ai/v3/public/reviews`,
				params: {
					sort_by: "created_at",
					product_id: productId,
					public_key: FERA_PUBLIC_KEY,
					page_size: 50,
				},
			});

			return data;
		},
		{ initialData, staleTime: 0 },
	);

	return {
		data: data?.data,
	};
};
